
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M12.7199 2.03001C6.62995 1.60001 1.59995 6.63001 2.02995 12.72C2.38995 18.01 7.00995 22 12.3099 22H15.9999C16.5499 22 16.9999 21.55 16.9999 21C16.9999 20.45 16.5499 20 15.9999 20H12.3299C8.59995 20 5.17995 17.58 4.24995 13.97C2.75995 8.17001 8.15995 2.76001 13.9599 4.26001C17.5799 5.18001 19.9999 8.60001 19.9999 12.33V13.43C19.9999 14.22 19.2899 15 18.4999 15C17.7099 15 16.9999 14.22 16.9999 13.43V12.18C16.9999 9.67001 15.2199 7.41001 12.7399 7.06001C9.33995 6.57001 6.46995 9.51001 7.07995 12.93C7.41995 14.84 8.90995 16.42 10.7999 16.87C12.6399 17.3 14.3899 16.71 15.5399 15.54C16.4299 16.76 18.2099 17.4 19.8399 16.75C21.1799 16.22 21.9999 14.85 21.9999 13.41V12.32C21.9999 7.01001 18.0099 2.39001 12.7199 2.03001ZM11.9999 15C10.3399 15 8.99995 13.66 8.99995 12C8.99995 10.34 10.3399 9.00001 11.9999 9.00001C13.6599 9.00001 14.9999 10.34 14.9999 12C14.9999 13.66 13.6599 15 11.9999 15Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-alternate-email`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconAlternateEmail

    ```js
    <b-new-b-icon-alternate-email />
    ```
</docs>


